import { NeutralIcon } from '@assets/icons/engagement';
import { HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectCoordinatesUnit } from '@redux/settings/settings.selectors';
import { formatCoordinatesToString } from '@utils/validation/coordinates.utils';
import DmsCoordinates from 'dms-conversion';

import { Coordinates } from '@/types/commons/commons.types';

type Props = {
  coordinates: Coordinates;
};

export default function EngagementPositionHeader({ coordinates }: Readonly<Props>) {
  const userSettingsUnit = useAppSelector(selectCoordinatesUnit);

  const coordinatesDMS = new DmsCoordinates(coordinates.latitude, coordinates.longitude);

  return (
    <HStack width="100%" height="120px" gap={2} backgroundColor="neutral.700">
      <Icon as={NeutralIcon} color="neutral.300" width="86px" height="86px" />
      <VStack gap={0.5} alignItems="start">
        <Text textStyle="md">{formatCoordinatesToString(coordinatesDMS, userSettingsUnit)}</Text>
      </VStack>
    </HStack>
  );
}
